import { render, staticRenderFns } from "./PaxList.vue?vue&type=template&id=57694818&"
import script from "./PaxList.vue?vue&type=script&lang=js&"
export * from "./PaxList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports